







































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';
import PolicyStatusBadge from '@/components/common/PolicyStatusBadge.vue';
import PolicyStatusCheckbox from '@/views/pages/policies/PolicyStatusCheckbox.vue';
import { PolicyFilterDto, PolicyStatus } from 'admiral-core';

@Component({
  name: 'horizontal-policy-status-select',
  components: { PolicyStatusCheckbox, PolicyStatusBadge },
})
export default class HorizonalPolicyStatusSelect extends Vue {
  @Prop({ type: Array, default: [] })
  selectedStatus!: PolicyStatus[];

  @Prop({ type: String, default: () => '' })
  clazz!: string;

  async update(obj: { status: PolicyStatus; value: boolean }) {
    const filter = this.policyFilter;

    let status = filter.status ? [...filter.status] : [];

    if (obj.value) {
      status.push(obj.status);
    } else {
      status = status.filter((item: PolicyStatus) => item !== obj.status);
    }

    await this.$store.dispatch('PreferencesModule/setPolicyFilter', {
      ...filter,
      status,
    });
  }

  get policyFilter(): PolicyFilterDto {
    return this.$store.getters[`PreferencesModule/getPolicyFilter`];
  }

  isChecked(status: PolicyStatus) {
    return this.selectedStatus.includes(status);
  }
}
